import React, { useMemo } from 'react';
import { Stepper } from '@shared/components/Stepper';
import { Zap } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { VerifyAccount } from './steps/VerifyAccount';
import { ConfirmEmail } from './steps/ConfirmEmail';
import { SetPassword } from './steps/SetPassword';
import { Done } from './steps/Done';
import { useTranslation } from 'react-i18next';

export const CreateAccountLanding = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { tenant, utilityName } = useParams<{ tenant?: string; utilityName?: string }>();

  const steps = useMemo(() => [
    {
      title: t("Verify Account"),
      slug: 'verify-account',
      component: <VerifyAccount />
    },
    {
      title: t("Confirm Email"),
      slug: 'confirm-email',
      component: <ConfirmEmail />
    },
    {
      title: t("Set Password"),
      slug: 'set-password',
      component: <SetPassword />
    },
    {
      title: t("Done"),
      slug: 'done',
      component: <Done />
    }
  ], [t]);

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a1526] via-[#103063] to-[#1e52a8] flex flex-col items-center p-4 font-sans justify-center">
      
      {/* Logo Area */}
      <div className="mb-8 flex flex-col items-center">
        <div className="flex items-center gap-3 text-white">
          <div className="p-1.5 bg-white/10 rounded-lg backdrop-blur-sm">
            <Zap className="text-blue-300 h-5 w-5" />
          </div>
          <div className="font-bold text-sm tracking-widest text-center leading-tight">
            SMART360<br/><span className="text-blue-200 text-[10px]">UTILITY PORTAL</span>
          </div>
        </div>
      </div>

      <div className="bg-[#F8F9FA] rounded-[2rem] w-full max-w-[680px] p-4 md:p-6 shadow-2xl border border-white/20 relative">
        <Stepper
          steps={steps}
          enableRouting={true}
          storageKey="create-account-stepper"
          autoSave={false}
          persistProgress={false}
          allowStepClick={false}
        />
      </div>
      
      <div className="mt-8 text-center text-sm text-gray-300">
        {t("Already have an account?")} <button type="button" onClick={() => navigate(tenant && utilityName ? `/login/${tenant}/${utilityName}` : '/login')} className="text-blue-200 font-semibold hover:underline">{t("Sign in")}</button>
      </div>

      {/* Footer */}
      {/* <div className="mt-4 text-white/50 text-xs text-center">
        © 2024 City of Lakewood Water & Sewer Authority
      </div> */}
    </div>
  );
};
